export default __webpack_public_path__ + "static/media/logoolic.a04959aa.png";